import { render, staticRenderFns } from "./PropertyPivotValues.vue?vue&type=template&id=d585a65e&scoped=true&lang=pug&"
import script from "./PropertyPivotValues.vue?vue&type=script&lang=js&"
export * from "./PropertyPivotValues.vue?vue&type=script&lang=js&"
import style0 from "./PropertyPivotValues.vue?vue&type=style&index=0&id=d585a65e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d585a65e",
  null
  
)

export default component.exports